import * as React from 'react'
import { FC } from 'react'

import Box from '@mui/material/Box'
import Collapse from '@mui/material/Collapse'

interface Props {
  children: React.ReactNode
  isOpen: boolean
}

export const EntityCardDrawer: FC<Props> = (props) => {
  const { children, isOpen } = props

  return (
    <Collapse in={isOpen} timeout="auto" unmountOnExit>
      <Box p={2} pt={3}>
        {children}
      </Box>
    </Collapse>
  )
}

EntityCardDrawer.displayName = 'EntityCardDrawer'
